import {
    hotspotPointFillOpacity,
    hotspotPointFillOpacity8Bit,
    hotspotSizes,
    HotspotStatus,
} from "@nova/constants"
import { escapeXmlEntities } from "@nova/util-strings"
import { Point } from "./data-create-hotspots-kml"

interface PlacemarkBuilder {
    build: (id: string, point: Point) => string
    buildStyle: () => string
}

const idGenerator = () => {
    let i = 1
    const time = Date.now().toString(36)

    return { getId: () => `hotspot-${i++}-${time}`, time }
}

const hotspotsToKML = (hotspots: Point[], placemarkBuilder: PlacemarkBuilder) => {
    // we shouldn't create hotspots kml when we filter them all out
    const mappedHotspots = hotspots.filter(
        (e) => e.status !== HotspotStatus.Out && e.status !== HotspotStatus.Removed
    )
    if (mappedHotspots.length === 0) {
        console.warn("All hotspots filtered")
        return undefined
    }

    const { getId, time } = idGenerator()

    return `<?xml version="1.0" encoding="UTF-8"?>
    <kml xmlns="http://www.opengis.net/kml/2.2" xmlns:atom="http://www.w3.org/2005/Atom" xmlns:gx="http://www.google.com/kml/ext/2.2" xmlns:kml="http://www.opengis.net/kml/2.2">
    <Document>
        <name>${`hotspots-${time}-name`}</name>
        ${mappedHotspots.map((hotspot) => placemarkBuilder.build(getId(), hotspot)).join("\n")}
        ${placemarkBuilder.buildStyle()}
    </Document>
</kml>`
}

const createPlacemark = (
    id: string,
    { label, latitude, longitude, color, sizeIndex }: Point,
    options: { relativeSizeEnabled?: boolean; styleId?: string }
) => {
    const hotspotSize =
        sizeIndex !== undefined && options.relativeSizeEnabled ? hotspotSizes[sizeIndex] : undefined

    const separatedColors = color || [255, 0, 0, hotspotPointFillOpacity8Bit] // #FF0000
    if (separatedColors && separatedColors.length === 4)
        separatedColors[3] *= hotspotPointFillOpacity
    else separatedColors?.push(hotspotPointFillOpacity8Bit)

    // puts color in description so it can be read in QGIS, should be revisited
    return `
        <Placemark id="placemark-${id}">
            <styleUrl>#${options.styleId ?? "redCircle"}</styleUrl>
            <name>${escapeXmlEntities(label)}</name>
            <description>${JSON.stringify({ color: separatedColors.join(", "), relativeSize: hotspotSize })}</description>
            <Point id="point-${escapeXmlEntities(label)}">
                <coordinates>${longitude},${latitude},0.0</coordinates>
            </Point>
        </Placemark>`
}

export { hotspotsToKML, createPlacemark }
export type { PlacemarkBuilder }
